import axios from "axios";
import { API_URL, SITE_URL2 } from "./config.js";
import { apiCall } from "./auth";


//add user
export const addUser = (formData) => apiCall(`${API_URL}addUser`, "POST", formData);

//get getuserbycolumn
export const getuserbycolumn = (formData) => apiCall(`${API_URL}getuserbycolumn`, "POST", formData);

//update user
export const updateUser = (formData) => apiCall(`${API_URL}updateuser`, "POST", formData);

//delete user
export const deleteUser = (formData) => apiCall(`${API_URL}deleteuser`, "POST", formData);

//get user booking
export const getUserBooking = (formData) => apiCall(`${API_URL}getUserBooking`, "POST", formData);

//get user booking
export const createkeapsysnsid = (formData) => apiCall(`${API_URL}createkeapsysnsid`, "POST", formData);

//get user booking
export const getKeapdataemail = (formData) => apiCall(`${API_URL}getKeapdataemail`, "POST", formData);

//get getuserbycolumn
export const getusershippingaddress = (formData) => apiCall(`${API_URL}getusershippingaddress`, "POST", formData);

//get getusershippingaddressbyid
export const getusershippingaddressbyid = (formData) => apiCall(`${API_URL}getusershippingaddressbyid`, "POST", formData);

//get deleteusershippingaddressApi
export const deleteusershippingaddressApi = (formData) => apiCall(`${API_URL}deleteusershippingaddress`, "POST", formData);

//get addusershippingaddress
export const addusershippingaddress = (formData) => apiCall(`${API_URL}addusershippingaddress`, "POST", formData);

//get addusershippingaddress
export const getduplicateemail = (formData) => apiCall(`${API_URL}getduplicateemail`, "POST", formData);

//get getduplicatekeapid
export const getduplicatekeapid = (formData) => apiCall(`${API_URL}getduplicatekeapid`, "POST", formData);

//get addusershippingaddress
export const margecontectApi = (formData) => apiCall(`${API_URL}margecontect`, "POST", formData);

//get addusershippingaddress
export const getstaxdataapi = (formData) => apiCall(`${API_URL}getstaxdata`, "POST", formData);

//get getstaxdatabyemail
export const getstaxdatabyemail = (formData) => apiCall(`${API_URL}getstaxdatabyemail`, "POST", formData);

//get updatedata
export const updatedata = (formData) => apiCall(`${API_URL}updatedata`, "POST", formData);

//get getmissmatchkeapdata
export const getmissmatchkeapdata = (formData) => apiCall(`${API_URL}getmissmatchkeapdata`, "POST", formData);

//get updatekeaptolillypad
export const updatekeaptolillypad = (formData) => apiCall(`${API_URL}updatekeaptolillypad`, "POST", formData);

//get getuserdataapi
export const getuserdataapi = (formData) => apiCall(`${API_URL}getuserwithoutbooking`, "POST", formData);

//get deleteUser
export const deleteMultipleUser = (formData) => apiCall(`${API_URL}deleteUsers`, "POST", formData);

//get old_customers_from_stax
export const old_customers_from_stax = (formData) => apiCall(`${API_URL}old_customers_from_stax`, "POST", formData);

//get delete_stax_customer
export const delete_stax_customer = (formData) => apiCall(`${API_URL}delete_stax_customer`, "POST", formData);

//get saveemaildata
export const saveemaildata = (formData) => apiCall(`${API_URL}saveemaildata`, "POST", formData);

//get deleteemaildata
export const deleteemaildata = (formData) => apiCall(`${API_URL}deleteemaildata`, "POST", formData);

//get getemaildatabyid
export const getemaildatabyid = (formData) => apiCall(`${API_URL}getemaildatabyid`, "POST", formData);

//get editemaildata
export const editemaildata = (formData) => apiCall(`${API_URL}editemaildata`, "POST", formData);

//get_client_frequency_report
export const get_client_frequency_report = (formData) => apiCall(`${API_URL}get_client_frequency_report`, "POST", formData);

//get getemailmessages
export const getemailmessages = () => apiCall(`${API_URL}getemailmessages`, "GET");

//get getuniquefsr
export const getuniquefsr = () => apiCall(`${API_URL}getuniquefsr`, "GET");

//get getkeapfsrlist
export const getkeapfsrlist = () => apiCall(`${API_URL}getkeapfsrlist`, "GET");

export const testsendemail = (formData) => apiCall(`${API_URL}testsendemail`, "POST", formData);
export const reminder = (formData) => apiCall(`${API_URL}reminder/save`, "POST", formData);
export const updateReminder = (formData) => apiCall(`${API_URL}reminder/update`, "POST", formData);
export const getreminder = (formData) => apiCall(`${API_URL}reminder/get/${formData}`, "GET");
